import { SubProductAction } from "features/product/types/actions.subproduct";
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { BiGridVertical, BiSpreadsheet, BiTrash } from "react-icons/bi";
import { useDispatch, useSelector } from "services/redux/rootReducer";
import {
    EditBox,
    InfoContainer,
    TrashBox,
} from "../modals/propertyManagementModal/propertyManagementModal.styled";
import { DragHandle, StyledTableBar } from "./tablesManager.styled";

interface Props {
    id: string;
    idx: number;
}

const TableBar: React.FC<Props> = ({ id, idx }) => {
    const { readOnlyMode, tables } = useSelector((state) => state.subProducts);
    const dispatch = useDispatch();

    const handleShowTable = () => {
        dispatch({
            type: SubProductAction.SET_SHOWN_TABLE_ID,
            id,
        });
        dispatch({
            type: SubProductAction.SET_TEMP_SHOWN_TABLE,
            table: tables[id],
        });
    };

    const handleDeleteTable = () => {
        if (!window.confirm("Are you sure you want to delete this table?"))
            return;
        dispatch({
            type: SubProductAction.REMOVE_TABLE,
            id,
        });
    };

    return (
        <Draggable
            isDragDisabled={readOnlyMode}
            key={id}
            draggableId={id}
            index={idx}
        >
            {(provided) => (
                <StyledTableBar
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                >
                    {!readOnlyMode && (
                        <DragHandle {...provided.dragHandleProps}>
                            <BiGridVertical />
                        </DragHandle>
                    )}
                    <InfoContainer>
                        <span>{tables[id].name.en || "(No English Name)"}</span>
                        <span>{tables[id].name.th || "(No Thai Name)"}</span>
                    </InfoContainer>
                    {!readOnlyMode && (
                        <TrashBox
                            onClick={handleDeleteTable}
                            title="Delete property"
                        >
                            <BiTrash />
                        </TrashBox>
                    )}
                    <EditBox title="Edit property" onClick={handleShowTable}>
                        <BiSpreadsheet />
                    </EditBox>
                </StyledTableBar>
            )}
        </Draggable>
    );
};

export default TableBar;
